<template>
  <div class="card rounded-5 p-5">
    <div class="d-flex">
      <AppIcon
        :name="card.icon"
        :size="24"
        class="blue-text mr-2 font-weight-bold"
      />
      <h5>{{ card.name }}</h5>
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
</script>
